document.addEventListener('DOMContentLoaded', function() {
  console.log('Script loaded'); // Debug: Confirm script runs

  // Element selection
  const variantElements = document.querySelectorAll('select[name="id"], variant-selects select, variant-radios input[type="radio"], product-form input[name="id"]');
  const customFields = document.querySelector('.js-customize-form');
  const productForm = document.querySelector('product-form form');

  if (!variantElements.length || !customFields || !productForm) {
    console.warn('Missing elements:', {
      variantElements: variantElements.length,
      customFields: !!customFields,
      productForm: !!productForm
    });
    return;
  }

  let variants = [];
  let retryCount = 0;
  const maxRetries = 5;

  // Load variants with retry limit
  function loadVariants() {
    const variantsJson = document.getElementById('ProductJSON') || // Generic fallback for product JSON
                        document.querySelector('script[type="application/json"]');
    if (variantsJson) {
      try {
        const parsedData = JSON.parse(variantsJson.textContent);
        variants = Array.isArray(parsedData) ? parsedData : (parsedData.variants || []);
        console.log('Parsed variants data:', parsedData);
        console.log('Variants array:', variants);
        if (variants.length === 0) console.warn('Variants array is empty');
      } catch (e) {
        console.error('Failed to parse variants JSON:', e);
      }
    } else if (retryCount < maxRetries) {
      console.warn('No variants JSON found, retrying...', retryCount + 1);
      retryCount++;
      setTimeout(loadVariants, 500);
    } else {
      console.error('Max retries reached, no variants JSON found');
    }
  }

  // Get selected variant ID
  function getSelectedVariantId() {
    const hiddenVariantInput = productForm.querySelector('input[name="id"]');
    if (hiddenVariantInput && hiddenVariantInput.value) {
      console.log('Selected variant ID from input:', hiddenVariantInput.value);
      return hiddenVariantInput.value;
    }
    console.warn('No variant ID detected from input');
    return null;
  }

  // Update form visibility and data
  function updateFormData() {
    const variantId = getSelectedVariantId();
    const selectedVariant = variants.find(v => v && v.id && v.id.toString() === variantId.toString());
    const productTitle = (document.querySelector('h1, .product__title h1')?.textContent || '').toLowerCase();
    console.log('Product title:', productTitle);
    console.log('Checking variant:', selectedVariant ? selectedVariant.title : 'None');

    const isCustomizeVariant = selectedVariant && selectedVariant.title.toLowerCase().includes('customize');
    const isBootProduct = productTitle.includes('boot');
    console.log('Is customize variant?', isCustomizeVariant, 'Is boot product?', isBootProduct);

    const customInputs = customFields.querySelectorAll('input, select');
    if (isCustomizeVariant && isBootProduct) {
      customFields.style.display = 'block';
      customFields.classList.add('active');
      customFields.scrollIntoView({ behavior: 'smooth', block: 'start' });
      console.log('Showing custom fields for:', selectedVariant.title);
    } else {
      customFields.style.display = 'none';
      customFields.classList.remove('active');
      customInputs.forEach(el => {
        el.value = '';
        el.setCustomValidity(''); // Reset validation
      });
      console.log('Hiding custom fields');
    }

    if (variantId && productForm.querySelector('input[name="id"]')) {
      productForm.querySelector('input[name="id"]').value = variantId;
      console.log('Updated hidden variant ID:', variantId);
    }
  }

  // Handle form submission
  productForm.addEventListener('submit', function(e) {
    console.log('Form submitted, checking data...');
    const formData = new FormData(productForm);
    const calfValue = customFields.querySelector('#calf-value');
    const calfUnit = customFields.querySelector('#calf-unit');
    const heightValue = customFields.querySelector('#height-value');
    const heightUnit = customFields.querySelector('#height-unit');
    const color = customFields.querySelector('#color');

    // Validation and property setting for Calf
    if (calfValue && calfUnit) {
      if (!calfValue.value || !calfUnit.value) {
        calfValue.setCustomValidity('Calf measurement and unit are required');
        e.preventDefault();
        return;
      }
      const calfProp = `${calfValue.value} ${calfUnit.value}`;
      formData.set('properties[Calf]', calfProp);
      calfValue.setCustomValidity('');
      console.log(`Forced property: properties[Calf] = ${calfProp}`);
    }

    // Validation and property setting for Height
    if (heightValue && heightUnit) {
      if (!heightValue.value || !heightUnit.value) {
        heightValue.setCustomValidity('Height measurement and unit are required');
        e.preventDefault();
        return;
      }
      const heightProp = `${heightValue.value} ${heightUnit.value}`;
      formData.set('properties[Height]', heightProp);
      heightValue.setCustomValidity('');
      console.log(`Forced property: properties[Height] = ${heightProp}`);
    }

    // Property setting for Color
    if (color && color.value) {
      formData.set('properties[Color]', color.value);
      console.log(`Forced property: properties[Color] = ${color.value}`);
    }

    formData.forEach((value, key) => console.log(`${key}: ${value}`));
  });

  // Event listeners and observer
  variantElements.forEach(el => {
    el.addEventListener('change', updateFormData);
    console.log('Added change listener to:', el);
  });

  const observer = new MutationObserver((mutations) => {
    console.log('DOM mutation detected', mutations);
    loadVariants();
    updateFormData();
  });
  observer.observe(productForm, { childList: true, subtree: true, attributes: true });

  // Initial load
  loadVariants();
  updateFormData();
  console.log('Initial form data check complete');
});